module.exports = __webpack_public_path__ + "static/media/shipping_lifestyle_desktop.f04383a2.webp";